<template>
    <div class="page-title-container">
        <p class="main-title">{{ title }}</p>
        <p v-if="subtitle" class="sub-title">{{ subtitle }}</p>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
    name: 'ReoPageTitle',
    props: {
        title: {
            type: String,
            required: true
        },
        subtitle: {
            type: String,
            default: ''
        }
    },
    data() {

        return {
        };

    },
});

</script>

<style lang="less" scoped>
    .page-title-container{
        padding: 60px 0;
        text-align: center;
        color: @font_primary;
        display: flex;
        flex-direction: column;
        gap: 16px;
        line-height: 1.2;
        @media @snapeak_mobile{
            padding: 20px 20px 30px;
        }
        .main-title{
            font-family: @font_01;
            font-size: @page-title-font-size;
            font-weight: @page-title-font-weight;
            color: @font_primary;
            @media @snapeak_mobile{
                font-size: @page-title-font-size-mobile;
            }
        }
        .sub-title{
            max-width: 710px;
            margin: 0 auto;
            font-size: @page-subtitle-font-size;
            @media @snapeak_mobile{
                font-size: @page-subtitle-font-size-mobile;
                max-width: unset;
            }
        }
    }
</style>
